// extracted by mini-css-extract-plugin
export var hidden = "_vt-0";